import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, Link } from 'react-router-dom';
import RegisterForm from './RegisterForm';
import { useAuth } from '../context/AuthContext'; // DÜZELTME: useAuth burada da import edilmeli

const RegisterPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // DÜZELTME: Artık login verisini beklemiyor. Sadece yönlendirme yapıyor.
  const handleRegisterSuccess = () => {
    navigate('/');
  };
  

 return (
    <div className="auth-page-container">
      <div className="auth-form-card">
        <h2 className="auth-title">{t('register_title')}</h2>
        <p className="auth-subtitle">{t('register_prompt')}</p>
        
        <RegisterForm idPrefix="page-" onSuccess={handleRegisterSuccess} /> 

        <p className="auth-redirect">
          {t('already_have_account')} <Link to="/login" className="auth-link">{t('login_button')}</Link>
        </p>
      </div>
    </div>
  );
};
export default RegisterPage;